import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  treeSideBar: false,
  tableLoading: false,
  currentFolderId: null,
  itemsTableContent: [],
  foldersTreeContent: [],
  currentDocument: {
    id: '',
    name: '',
    title: '',
    records: []
  },
  documentsList: [],
  error: false,
  showError: false,
  defaultDocument: 'rezervirovanie',
  emptyDocuments: {
    rezervirovanie: {
      id: '',
      name: 'rezervirovanie',
      title: 'Новое резервирование',
      records: []
    },
    schet: {
      id: '',
      name: 'schet',
      title: 'Новый счет',
      records: []
    }
  },
  itemsDisplaySettings: {
    showTranzit: true,
    showRezerv: true,
    showPriemka: true,
    showRecommendedOnly: false
  },
  searchQuery: '',
  isSaving: false
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
